import { FC } from 'react';
import { ReactComponent as Minus } from 'images/newIcons/minus.svg';
import { ReactComponent as Plus } from 'images/newIcons/plus.svg';

import { IconButton } from 'components/ui/IconButton';

interface ScaleControlsProps {
  scale: number | string;
  decreaseScale: () => void;
  increaseScale: () => void;
}

export const ScaleControls: FC<ScaleControlsProps> = ({
  scale,
  decreaseScale,
  increaseScale,
}) => (
  <div className="flex items-center">
    <span className="mr-1 tpg-c1">{scale}%</span>
    <IconButton
      icon={<Minus className="w-5 h-5" />}
      classNames={{
        container: '!text-tpg_base hover:!text-bright_product',
      }}
      onClick={decreaseScale}
    />
    <IconButton
      icon={<Plus className="w-5 h-5" />}
      classNames={{
        container: '!text-tpg_base hover:!text-bright_product',
      }}
      onClick={increaseScale}
    />
  </div>
);
